import React, { useState } from 'react'
import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import { Alert, Col, Row } from 'react-bootstrap'
import ReportFooter from '../../ReportsFooter/ReportFooter'

const IncidentsCountWmrcGroupTable = ({
    isLoading,
    data,
    handleColumnSort,
    downloadPDF,
    tableOptions,
    pageCount,
    totaldata,
    handlePageClick,
    handleRowsPerPage,
    reportTableData,
    downloadExcel,
    reportCode,
}) => {
    const size = useWindowSize()
    const [currentRow, setCurrentRow] = useState(null)

    const totalIncidents =
        data?.reduce((sum, item) => sum + (item.incident_count || 0), 0) || 0

    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">Incident Count WMRC Group Report</h1>

                <ReactExpandableTable
                    currentRow={currentRow}
                    isLoading={isLoading}
                    data={data || []}
                    mobileColumns={mobileColumns}
                    removePagination={false}
                    handleColumnSort={handleColumnSort}
                    setCurrentRow={setCurrentRow}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    totaldata={totaldata}
                    handleRowsPerPage={handleRowsPerPage}
                    handlePageClick={handlePageClick}
                />

                <ReportFooter
                    BackText="Back"
                    PdfText="PDF"
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    reportTableData={data}
                     reportCode={reportCode}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">Incident Count WMRC Group Report</h1>

            <ReactDataTable
                isLoading={isLoading}
                data={data || []}
                columns={columns}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                totaldata={totaldata}
                handleRowsPerPage={handleRowsPerPage}
                removePagination={false}
                handleColumnSort={handleColumnSort}
                handlePageClick={handlePageClick}
            />

            <ReportFooter
                BackText="Back"
                PdfText="PDF"
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportTableData={data}
                 reportCode={reportCode}
            />
        </>
    )
}

export default IncidentsCountWmrcGroupTable

{
    /* <div className="p-3 my-3 rounded-lg shadow-sm border newReport">
                <Row className="align-items-center">
                    <Col className="d-flex justify-content-start align-items-center clrText">
                        <span className="me-2 text-lg fw-medium text-gray-700">
                            Total Incident Count:
                        </span>
                        <span className="fw-semibold">{totalIncidents}</span>
                    </Col>
                </Row>
            </div> */
}
